import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { PedidoService } from "src/app/core/services/pedido-service";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import Swal from "sweetalert2";
import { InitProvider } from "src/app/core/services/init-provider";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { DateRangeFactoryService } from "src/app/core/services/date-range-factory.service";
import { DateRangeOption } from "src/app/core/interfaces/date-range";
import { formatDate } from "@angular/common";
import { RelatorioService } from "src/app/core/services/relatorios.service";
import { ToastrService } from "ngx-toastr";
import "@angular/localize/init";
declare var $: any;
import * as CryptoJS from "crypto-js";

type Boleto = {
  lancamento: number;
  cliente: number;
  numeroDocumento: string;
  nossoNumero: string;
  dataVencimento: string;
  valorBoleto: number;
  sacadoNome: string;
  sacadoCnpj: string;
  sacadoCep: string;
  sacadoBairro: string;
  sacadoLogradouro: string;
  sacadoCidade: string;
  sacadoEstado: string;
  codBanco: string;
  conta: string;
  agencia: string;
  carteira: string;
  dataEmissao: string;
  cedenteNome: string;
  cedenteCnpj: string;
  instrucao1: string;
  instrucao2: string;
  instrucao3: string;
  ativo: boolean;
};

@Component({
  selector: "app-page-meus-dados-b2c",
  templateUrl: "./page-meus-dados-b2c.component.html",
  styleUrls: ["./page-meus-dados-b2c.component.css"],
})
export class PageMeusDadosB2cComponent implements OnInit {
  public list = 0;
  public emIntegracao = 0;
  public erro = 0;
  public aguardandoFaturamento;
  public formPassword: FormGroup;
  public documentLabel = "CPF";
  public documentMask = "000.000.000-00";
  public errorPassword: Boolean = false;
  public errorMsgPassword: String;
  public boletos: Boleto[] = [];
  public boletosCopy: Boleto[] = [];
  dataCliente;
  public paginaAtual = 1;
  public totalPaginas = 0;
  public empty = false;
  public clients: any[] = [];
  public boletoSelected;
  public dateFormat = $localize`DD/MM/YYYY`;
  public arrSacado = [];
  public notasPedido = [];
  public pedidosCliente = [];
  public totalElements: number = 0;
  dateRange = [];
  nome = "";
  documento = "";
  cnpj = "";
  iconsList = ["check", "approval", "verified", "pending_actions"];
  cardsHoje = [];
  public cliente;
  cardsSemana = [];
  colunaOrdenada: string | null = null;
  direcaoOrdenacao: "asc" | "desc" = "asc";
  pago = true;
  pagoSearch = true
  cardsMes = [];
  loading = false;
  public ranges: DateRangeOption[];
  constructor(
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private pedidoService: PedidoService,
    public relatorioService: RelatorioService,
    private rangeFactory: DateRangeFactoryService,
    public initProvider: InitProvider,
    private toastService: ToastrService,
    private formBuilder: FormBuilder
  ) {
    this.list = 0;
    this.route.queryParams.subscribe((params) => {
      if (params["list"]) this.list = params["list"];
    });
    this.formPassword = this.formBuilder.group({
      senhaAntiga: ["", Validators.required],
      senhaNova: ["", Validators.required],
      senhaNovaConfirm: ["", Validators.required],
    });
  }

  get paginasArray(): number[] {
    return Array(this.totalPaginas).fill(0);
  }
  get visiblePages(): number[] {
    const maxVisible = 5;

    if (!this.totalPaginas) return [];

    let start = Math.max(1, this.paginaAtual - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > this.totalPaginas) {
      end = this.totalPaginas;
      start = Math.max(1, end - maxVisible + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  getBoletos(pagina) {
    this.loading = true;
    this.paginaAtual = pagina;

    const params: any = {
      pagina: this.paginaAtual,
      nome: this.nome,
      cnpj: this.cnpj,
      documento: this.documento,
      pago: !this.pago,
    };

    if (this.dateRange?.[0]) {
      params.dataInicial = formatDate(this.dateRange[0], "yyyy-MM-dd", "en");
    }

    if (this.dateRange?.[1]) {
      params.dataFinal = formatDate(this.dateRange[1], "yyyy-MM-dd", "en");
    }

    this.usuarioService.getBoletos(
      params,
      function (resp) {
        this.totalElements = resp.total_elementos;
        this.boletosCopy = resp.lista_boletos;
        this.loading = false;
        this.boletos = resp.lista_boletos;
        this.totalPaginas = resp.paginas;

        let values = [];
        this.pagoSearch = this.pago;

        for (let row in resp.lista_boletos) {
          values.push(resp.lista_boletos[row]["sacadoNome"]);
        }

        this.arrSacado = [...new Set(values)];
        this.empty = this.boletos.length < 1;
      }.bind(this)
    );

    this.loading = false;
  }
  ngOnInit() {
    this.ranges = this.rangeFactory.getDefaultRanges();

    // this.getBoletos(1);
    this.ordenar("dataVencimento");
    this.pedidoService.getIntegracoes(
      function (resp) {
        this.cardsHoje = resp.cardsHoje;
        this.cardsSemana = resp.cardsSemana;
        this.cardsMes = resp.cardsMes;
        this.emIntegracao = resp.pedidos_em_integracao;
        this.erro = resp.pedidos_erro;
        this.aguardandoFaturamento = resp.ag_faturamento;
      }.bind(this),
      function (e) {
        console.log(e);
      }
    );
    this.getClientes();
  }

  private dividirEmPaginas(lista: Boleto[], tamanho: number = 10): Boleto[][] {
    const paginas: Boleto[][] = [];

    for (let i = 0; i < lista.length; i += tamanho) {
      paginas.push(lista.slice(i, i + tamanho));
    }

    return paginas;
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Permite somente números (charCode entre 48 e 57) e tecla "Backspace" (charCode 8)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  goTo(value: number) {
    this.list = value;
  }
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData("text");

    // Remove caracteres não numéricos do texto colado
    pastedText = pastedText.replace(/\D/g, "");

    // Insere o texto filtrado no input
    event.preventDefault();
    document.execCommand("insertText", false, pastedText);
  }

  printBoletoPdf(boleto: Boleto) {
    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
      "Content-Type": "application/json",
    });

    fetch(
      `${Configuracoes.API}impressoes/boleto?pedido=${boleto.numeroDocumento}&lancamento=${boleto.lancamento}`,
      {
        method: "GET",
        headers,
      }
    )
      .then((response) => response.json()) // 👈 aqui vem o JSON
      .then((jsonResposta) => {
        // agora envia esse JSON para a outra requisição
        this.relatorioService.getBoletoPdf(
          jsonResposta,
          (pdf) => {
            console.log(pdf);
            window.open(pdf.arquivo);
          },
          (erro) => {
            console.error("Erro ao gerar PDF", erro);
          }
        );
      })
      .catch((err) => {
        console.error("Erro ao buscar dados do boleto", err);
      });
  }

  ordenar(coluna: string): void {
    // Alterna direção
    if (this.colunaOrdenada === coluna) {
      this.direcaoOrdenacao = this.direcaoOrdenacao === "asc" ? "desc" : "asc";
    } else {
      this.colunaOrdenada = coluna;
      this.direcaoOrdenacao = "asc";
    }

    const listaCompleta = this.boletos.flat();

    listaCompleta.sort((a: any, b: any) => {
      let valorA = a[coluna];
      let valorB = b[coluna];

      // Trata datas
      if (coluna === "dataVencimento") {
        valorA = new Date(valorA).getTime();
        valorB = new Date(valorB).getTime();
      }

      // Trata string
      if (typeof valorA === "string") {
        valorA = valorA.toLowerCase();
        valorB = valorB.toLowerCase();
      }

      if (valorA > valorB) return this.direcaoOrdenacao === "asc" ? 1 : -1;

      if (valorA < valorB) return this.direcaoOrdenacao === "asc" ? -1 : 1;

      return 0;
    });

    // 3️⃣ Recria as páginas
    this.boletos = listaCompleta;
  }

  onSubmitPassword() {
    if (!this.formPassword.valid) {
      this.errorPassword = true;
      this.errorMsgPassword = $localize`Confira o formulário corretamente!`;
      return;
    }

    if (
      this.formPassword.value.senhaNova !=
      this.formPassword.value.senhaNovaConfirm
    ) {
      this.errorPassword = true;
      this.errorMsgPassword = $localize`Nova senha e a confirmação não conferem!`;
      return;
    }

    if (this.formPassword.valid && !this.usuarioService.loading)
      this.usuarioService.updatePassword(
        this.formPassword.value.senhaAntiga,
        this.formPassword.value.senhaNova,
        function (resp) {
          this.errorPassword = false;
          this.formPassword.reset();
          Swal.fire($localize`Senha atualizada com sucesso!`, "", "success");
        }.bind(this),
        function (error) {
          //console.log(error);
          this.errorPassword = true;
          this.errorMsgPassword = error._body;
        }.bind(this)
      );
  }

  getClientes = async () => {
    await this.usuarioService.getClientes(
      {
        busca: "",
        id_usuario: this.initProvider.usuario.id,
      },
      function (resp) {
        if (resp.length === 1) {
          this.usuarioService.getClientesId(
            { id_cliente: resp[0].id },
            (resp) => {
              this.cliente = resp;
            }
          );
        }
      }.bind(this)
    );
  };

  getPedidoNotas(id = 0, page = 1) {
    // if(this.clienteSelecionadoPedidos === undefined){
    //   this.toastService.error(
    //     $localize`Selecione um cliente`,
    //     $localize`Notas`,
    //     {
    //       timeOut: 4000,
    //     }
    //   );
    //   return
    // }
    let data: any = {};
    if (this.dataCliente !== undefined) {
      data["dataInicial"] = formatDate(this.dataCliente[0], "dd/MM/yyyy", "en");
      data["dataFinal"] = formatDate(this.dataCliente[1], "dd/MM/yyyy", "en");
    }
    // if (id === 0) {
    //   this.toastService.warning("Selecione um cliente", "Notas");
    //   return;
    // }
    this.pedidoService.getPedidoNotas(
      { cliente: id, pagina: page - 1, ...data },
      function (response) {
        if (response.total_elementos > 0) {
          this.pagTotaisNotas = response.paginas;
          this.notasPedido = response.lista_notas;
          this.totalElementsNotas = response.total_elementos;
        } else {
          this.pagTotaisNotas = 0;
          this.notasPedido = [];
          this.totalElementsNotas = 0;
        }
      }.bind(this)
    );
  }

  getPedidoErp(id = 0, page = 1) {
    let data: any = {};
    if (this.dataCliente !== undefined) {
      data["dataInicial"] = formatDate(this.dataCliente[0], "dd/MM/yyyy", "en");
      data["dataFinal"] = formatDate(this.dataCliente[1], "dd/MM/yyyy", "en");
    }
    // if(this.clienteSelecionadoPedidos === undefined){
    //   this.toastService.error(
    //     $localize`Selecione um cliente`,
    //     $localize`Notas`,
    //     {
    //       timeOut: 4000,
    //     }
    //   );
    //   return
    // }
    // if (id === 0) {
    //   this.toastService.warning("Selecione um cliente", "Pedidos");
    //   return;
    // }
    this.pedidoService.getPedidoErp(
      { cliente: id, pagina: page - 1, ...data },
      function (response) {
        if (response.total_elementos > 0) {
          this.pagTotaisErp = response.paginas;
          this.pedidosCliente = response.lista_pedidos;
          this.totalElementsErp = response.total_elementos;
        } else {
          this.pagTotaisErp = 0;
          this.pedidosCliente = [];
          this.totalElementsErp = 0;
        }
      }.bind(this)
    );
  }
}
